import TreeMapFilterItem from "../tree-map-filter-item";
import TreeMapSubFilterCard from "../tree-map-sub-filter-card";

import { useTreeMapFilterAssetType } from "./tree-map-filter-asset-type.hook";

const TreeMapFilterAssetType = () => {
  const { filterItems, onToggle } = useTreeMapFilterAssetType();

  return (
    <TreeMapSubFilterCard type="assetType" closed>
      {filterItems.map(({ id, name, count, checked }) => (
        <TreeMapFilterItem
          key={id}
          title={name}
          count={count}
          checked={checked}
          onToggle={() => onToggle(id, checked)}
        />
      ))}
    </TreeMapSubFilterCard>
  );
};

export default TreeMapFilterAssetType;
